module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/order-history/order-history.component.css
// module id = ./src/app/admin/order-history/order-history.component.css
// module chunks = main